import { useCallback } from 'react';

import { Button } from '../../../../atoms';
import { TrashIcon } from '../../../../icons';
import { useAdvancedFiltersContext } from '../AdvancedFilters.context';

import { AdvancedFiltersFieldSelect } from './AdvancedFiltersFieldSelect';
import { AdvancedFiltersOperatorSelect } from './AdvancedFiltersOperatorSelect';
import { AdvancedFiltersValueInput } from './AdvancedFiltersValueInput';

interface AdvancedFiltersConditionRowProps {
  rowId: string;
}

export const AdvancedFiltersConditionRow = ({
  rowId,
}: AdvancedFiltersConditionRowProps) => {
  const { state, dispatch } = useAdvancedFiltersContext();

  const { conditions } = state;
  const { field } = conditions[rowId];

  const shouldRemove = Object.keys(state.conditions).length > 1;

  const handleRemoveRow = useCallback(() => {
    if (shouldRemove) {
      dispatch({ type: 'REMOVE_CONDITION', payload: { rowId } });
    } else {
      dispatch({ type: 'RESET' });
    }
  }, [shouldRemove, dispatch, rowId]);

  return (
    <div
      className="flex flex-row w-full h-fit items-center"
      data-testid={`${field}-condition`}
    >
      <div className="w-full grid grid-cols-[1fr_1fr_1fr] gap-0">
        <AdvancedFiltersFieldSelect rowId={rowId} />
        <AdvancedFiltersOperatorSelect rowId={rowId} />
        <AdvancedFiltersValueInput rowId={rowId} />
      </div>

      <Button
        id={`${field}-advanced-filter-remove-button`}
        aria-label={`Remove ${field} advanced filter`}
        data-testid={`${field}-advanced-filter-remove-button`}
        size="icon"
        variant="ghost"
        className="ml-1"
        onClick={handleRemoveRow}
      >
        <TrashIcon />
      </Button>
    </div>
  );
};
